<app-page-shell variant="default">
    <div [hidden]="!allProjectList()?.length && !isOnLoad()"
         class="test-{{allProjectList()?.length}} card card-box mb-5 my-project border-0 shadow-none">
      <div class="page-header header">
        <div class="page-header__title">
          <h2 class="mb-0 title">My Snöballed Projects</h2>
        </div>
        @if (currentUser()?.can('create-new', 'project')) {
        <div class="page-header__actions start-project">
          <a class="btn btn-sm btn-primary pull-right"
             routerLink="/{{routes.createProject()}}" sbEntityLink role="button">
            <span class="btn-wrapper--icon"><i class="fa fa-plus"></i></span>
            <span class="btn-wrapper--label">Start Project</span>
          </a>
        </div>
        }
      </div>
      <div class="project-toolbar project-name-dropdown">
        <div class="project-toolbar__selects client-dropdown-position">
          @if (currentUser()?.can('index.all', 'project')) {
          <div class="client-dropdown">
            <app-auto-complete-select
              [hideLabel]="true"
              [isCreatable]="false"
              [onlyBottomBorder]="false"
              [placeholder]="'Select Client'"
              [selectOptions]="planners()"
              [selectedValue]="selectedClient !== 'All' ? selectedClient : null"
              (optionSelected)="projectList($event)"
              (searchValue)="handleSearchValue($event)"
              (scrollToEnd)="handleScroll()"
            ></app-auto-complete-select>
          </div>
          }
          @if (currentUser()?.can('index.all', 'project')) {
          <div class="client-dropdown">
            <app-auto-complete-select
              [hideLabel]="true"
              [isCreatable]="false"
              [onlyBottomBorder]="false"
              [placeholder]="'Select Organization'"
              [selectOptions]="organizations()"
              [selectedValue]="selectedOrganization !== 'All' ? selectedOrganization : null"
              (optionSelected)="onOrganizationSelected($event)"
            ></app-auto-complete-select>
          </div>
          }
        </div>
        <div class="project-toolbar__controls customize-email">
          <label class="project-toolbar__stats" for="customize_columns">
            <input id="customize_columns" placeholder="" [checked]="showAll" (change)="showAllColumns($event)"
                   type="checkbox">
            <span>Display Project Stats</span>
          </label>
          <div class="project-toolbar__status" role="group" aria-label="Project status">
            <a class="filters" [class.active-status]="selectedStatus === 'all'" (click)="onChangeProjectStatus('all')">
              All
            </a>
            <a class="filters" [class.active-status]="selectedStatus === 'active'" (click)="onChangeProjectStatus('active')">
              Active
            </a>
            <a class="filters" [class.active-status]="selectedStatus === 'draft'" (click)="onChangeProjectStatus('draft')">
              Draft
            </a>
            <a class="filter-last" [class.active-status]="selectedStatus === 'completed'" (click)="onChangeProjectStatus('completed')">
              Completed
            </a>
          </div>
          <div class="project-toolbar__view" role="group" aria-label="View type">
            <button type="button" [class]="{'active-btn': viewType === 'card', 'inactive-btn': viewType !== 'card'}" class="btn btn-default btn-sm list-button" (click)="changeViewType('card')">
              <i class="fa fa-th-large me-1"></i>
              Card
            </button>
            <button type="button" [class]="{'active-btn': viewType === 'list', 'inactive-btn': viewType !== 'list'}" class="btn btn-default btn-sm card-button" (click)="changeViewType('list')">
              <i class="fa fa-th-list me-1"></i>
              List
            </button>
          </div>
        </div>
      </div>

      <div class="project-list" [class.project-list--cards]="viewType === 'card'" [class.project-list--stats]="showAll">
        <app-sb-table
          [rows]="projects()"
          [totalRows]="totalRows()"
          [columns]="tableColumns"
          [options]="tableOptions"
          [viewMode]="viewType === 'card' ? 'card' : 'list'"
          (stateChange)="onTableState($event)">

          <ng-template sbTableCell="image" let-project>
            <div class="cursor-pointer">
              @if (project.image) {
              <img class="image-thumbnail" [src]="project.image" alt=""/>
              }
            </div>
          </ng-template>
          <ng-template sbTableCell="title" let-project>
            <div class="fw-bold">
              <div class="d-flex align-items-start">
                @if (project.notes) {
                  <button type="button" class="info-button position-absolute" [ngbPopover]="notesTemplate"
                          triggers="mouseenter:mouseleave" placement="auto" container="body"
                          [popoverClass]="'info-popover'">
                    <i class="fa fa-file-text-o" aria-hidden="true"></i>
                  </button>

                  <ng-template #notesTemplate>{{project.notes}}</ng-template>
                }
                <div>
                  <span class="cursor-pointer"
                        routerLink="/{{routes.campaigns({projectId: project.id})}}">{{project.title}}</span>
                  <span class="d-block client-container">
                <small class="me-1"
                       title="Project Status">{{getProjectStatus(project)}}</small>
                <small>-</small>
                <small class="me-1 ms-1" title="Project Code">{{project.code}}</small>
                <small>-</small>
                <small title="Client Name" class="ms-1  cursor-pointer"
                       (click)='projectListByClient(project.client)'>{{project.client.name}}</small>
                @if (project.client?.organization?.name) {
                  <small> -</small>
                  <small title="Organization Name" class="ms-1">{{project.client.organization.name}}</small>
                }
              </span>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template sbTableCell="campaign_count" let-project>
            <div routerLink="/{{routes.campaigns({projectId: project.id})}}" class="cursor-pointer">
              {{project.campaign_count}}
            </div>
          </ng-template>
          <ng-template sbTableCell="influencers_count" let-project>{{project.total_influencer_count}}</ng-template>
          <ng-template sbTableCell="click_rate" let-project>{{project.emailProgress?.opened}}/ <span class="click-rate">{{getOpenClickRate(project)}}%</span></ng-template>
          <ng-template sbTableCell="pageviews_count" let-project>{{project.pageviews_count ? project.pageviews_count : '-'}}</ng-template>
          <ng-template sbTableCell="referrals_count" let-project>{{project.referrals_count}}/<span> {{getReferralsRatePercentage(project)}}%</span></ng-template>
          <ng-template sbTableCell="created_at" let-project>{{project.created_at}}</ng-template>
          <ng-template sbTableActions let-project>
            <ng-container *ngTemplateOutlet="projectMenu; context: {$implicit: project}"></ng-container>
          </ng-template>

          <ng-template sbTableCard let-project>
            <div class="project-card project-card-view">
              <div class="fw-bold project-client-name">
                <div class="d-flex align-items-center justify-content-between project-client-details">
                  <div class="d-flex align-items-center project-client-name-details">
                    <div class="img-wrapper me-3 cursor-pointer" [class.image-cover]="!project.image">
                      @if (project.image) {
                      <img class="image-thumbnail img-fluid" [src]="project.image" alt=""/>
                      }
                    </div>
                    <div class="name">
                      @if (project.notes) {
                        <button type="button" class="info-button position-absolute" [ngbPopover]="notesTemplate2"
                                triggers="mouseenter:mouseleave" placement="auto" container="body"
                                [popoverClass]="'info-popover'">
                          <i class="fa fa-file-text-o" aria-hidden="true"></i>
                        </button>

                        <ng-template #notesTemplate2>{{project.notes}}</ng-template>
                      }
                      <div class="project-name-details">
                        <span class="cursor-pointer"
                              routerLink="/{{routes.campaigns({projectId: project.id})}}">{{project.title}}</span>
                        <span class="d-block">
                        <small class="me-1">{{getProjectStatus(project)}}</small>
                        <small>-</small>
                        <small class="me-1 ms-1">{{project.code}}</small>
                        <small>-</small>
                        <small class="cursor-pointer ms-1"
                               (click)='projectListByClient(project.client)'>{{project.client.name}}</small>
                        @if (project.client?.organization?.name) {
                          <small> -</small>
                          <small class="ms-1">{{project.client.organization.name}}</small>
                        }
                      </span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <ng-container *ngTemplateOutlet="projectMenu; context: {$implicit: project}"></ng-container>
                  </div>
                </div>
              </div>
              <div class="project-status">
                <div class="campaign" routerLink="/{{routes.campaigns({projectId: project.id})}}">
                  {{project.campaign_count}} campaigns
                </div>
                <div>
                  <div class="card-header--actions">
                    <button class="btn btn-primary btn-sm"
                            routerLink="/{{routes.createCampaign({projectId: project.id})}}">
                      <span class="btn-wrapper--icon"><i class="fa fa-plus"></i></span>
                      <span class="btn-wrapper--label">Start Campaign</span>
                    </button>
                  </div>
                </div>
              </div>
              <div [class.d-none]="!showAll && currentUser()?.can('index.all', 'project')" class="project-social-details">
                <div class="project-social-bg">
                  <div class="d-flex align-items-center">
                    <div class="rounded-circle bg-neutral-first text-white me-3 text-center">
                      <li class="fa fa-users" style="color: #4ab8e3;"></li>
                    </div>
                    <div class="">
                      <div
                        class="font-size-xxl fw-bold social-count">{{project.total_influencer_count}}</div>
                      <div class="pb-1 social-name">Influencers</div>
                    </div>
                  </div>
                </div>
                <div class="project-social-bg">
                  <div class="d-flex align-items-center">
                    <div class="rounded-circle bg-neutral-first text-white me-3 text-center">
                      <li class="fa fa-envelope" style="color: #4ab8e3;"></li>
                    </div>
                    <div class="">
                      <div class="font-size-xxl fw-bold social-count">{{project.emailProgress?.opened}}/ <span
                        class="click-rate">{{getOpenClickRate(project)}}%</span></div>
                      <div class="pb-1 social-name">Open/Click Rate</div>
                    </div>
                  </div>
                </div>
                <div class="project-social-bg">
                  <div class="d-flex align-items-center">
                    <div class="rounded-circle bg-neutral-first text-white me-3 text-center">
                      <li class="fa fa-eye" style="color: #4ab8e3;"></li>
                    </div>
                    <div class="">
                      <div
                        class="font-size-xxl fw-bold social-count">{{project.pageviews_count ? project.pageviews_count : '0'}}</div>
                      <div class="pb-1 social-name">Impressions</div>
                    </div>
                  </div>
                </div>
                <div class="project-social-bg">
                  <div class="d-flex align-items-center">
                    <div class="rounded-circle bg-neutral-first text-white me-3 text-center">
                      <li class="fa fa-usd" style="color: #4ab8e3;"></li>
                    </div>
                    <div class="">
                      <div class="font-size-xxl fw-bold social-count">{{getReferralsRatePercentage(project)}}%
                      </div>
                      <div class="pb-1 social-name">Conversion</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </app-sb-table>
      </div>
    </div>
    @if (!(loader$ | async) && !allProjectList()?.length && !isOnLoad()) {
      <div class="no-data">
        <div class="container h-100">
          <div class="row h-100 align-items-center">
            <div class="col-12">
              <div class="no-data-bg text-center">
                <div class="content">
                  <h3 class="title">
                    Welcome to Snöball!
                  </h3>
                  <div class="img-wrapper">
                    <img src="/assets/images/my-project-no-content.svg" class="img-fluid" alt="no-content-images">
                  </div>
                  <p class="details">
                    Snöball makes it easy to scale influencer marketing to grow your events. Mobilize your attendees,
                    speakers, sponsors and exhibitors to social-proof your event. We’ll help you get started.
                  </p>
                  @if (currentUser()?.can('create-new', 'project')) {
                  <a href="#" class="new-project-btn" routerLink="/{{routes.createProject()}}" sbEntityLink>
                    <i class="fa fa-plus"></i>
                    Start a new project
                  </a>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
</app-page-shell>

<!-- A project's menu: in the list's actions column and in each card's corner. -->
<ng-template #projectMenu let-project>
  <button class="btn-icon float-end" mat-icon-button [matMenuTriggerFor]="menu"
          aria-label="Example icon-button with a menu">
    <span class="fa fa-ellipsis-v"></span>
  </button>
  <mat-menu #menu="matMenu" class="campaign-popover">
    <a class="dropdown-item d-flex align-items-center"
       routerLink="/{{routes.createCampaign({projectId: project.id})}}">
      <i class="fa fa-plus me-2" aria-hidden="true"></i>
      Start a new campaign
    </a>
    <a class="dropdown-item d-flex align-items-center" [routerLink]="['/projects', project.id, 'edit']" sbEntityLink>
      <i class="fa fa-pencil me-2"></i>
      Edit
    </a>
    <a class="dropdown-item d-flex align-items-center"
       routerLink="/{{routes.campaigns({projectId: project.id})}}">
      <i class="fa fa-list me-2" aria-hidden="true"></i>
      Manage Campaigns
    </a>
    <a class="dropdown-item d-flex align-items-center"
       routerLink="/{{routes.statistics({projectId: project.id})}}">
      <i class="fa fa-eye me-2"></i>
      View Results
    </a>
    <a class="dropdown-item d-flex align-items-center" (click)="copyProject(project.id)">
      <i class="fa fa-clipboard me-2"></i>
      Duplicate
    </a>
    <a class="dropdown-item d-flex align-items-center" (click)="deleteProject(project.id)">
      <i class="fa fa-trash me-2"></i>
      Delete
    </a>
  </mat-menu>
</ng-template>

<!-- Body of the delete confirmation (SbModalService). It names the people who decide
     before the user commits, so nobody confirms a deletion without knowing who approves it. -->
<ng-template #deleteProjectTpl>
  <!-- Still running: the server refuses both request types until the activity end date
       has passed, so the dialog explains that and offers no choice. Opened with a single
       Close button (see confirmDeleteProject), so there is nothing here to continue to. -->
  @if (deleteConfirm?.isActive) {
    <p>
      This project <b>cannot be deleted or anonymized yet</b>.
      @if (deleteConfirm.endsAt) {Its activity end date is
        <b>{{ deleteConfirm.endsAt | date:'longDate' }}</b>, which is still ahead.} @else {It has <b>no activity end date</b>, so it counts as still
        active.}
      <ng-template #noEndDate>It has <b>no activity end date</b>, so it counts as still
        active.</ng-template>
    </p>
    <p class="mb-0 text-muted">
      To remove it, first update the project's <b>activity end date</b> to a date that has
      passed, then come back here. A project is judged finished from the day after that date.
    </p>
  }

  @if (deleteConfirm && !deleteConfirm.isActive) {
    <!-- Anonymize first and selected by default: the choice that keeps the project and its
         reports. Deleting permanently is always picked on purpose. -->
    <div class="dp-type-choice mb-3">
      <div class="form-check mb-2">
        <input type="radio" id="dp-type-anonymize" name="dp-type" class="form-check-input"
               [value]="'anonymize'" [(ngModel)]="deleteConfirm.type" [ngModelOptions]="{standalone: true}"
               [disabled]="deleteConfirm.isAnonymized">
        <label class="form-check-label" for="dp-type-anonymize">
          <b>Anonymize</b> ({{ anonymizeSummary }})
          @if (deleteConfirm.isAnonymized) {
          <span class="d-block text-muted small">
            Already anonymized, so it can only be deleted now.
          </span>
          }
        </label>
      </div>
      @if (deleteConfirm.type === 'anonymize' && !deleteConfirm.isAnonymized) {
      <app-anonymize-scope-choice
                                  class="ps-4 mb-2" idPrefix="dp-delete-scope" [(value)]="deleteConfirm.scope">
      </app-anonymize-scope-choice>
      }
      <div class="form-check">
        <input type="radio" id="dp-type-delete" name="dp-type" class="form-check-input"
               [value]="'delete'" [(ngModel)]="deleteConfirm.type" [ngModelOptions]="{standalone: true}">
        <label class="form-check-label" for="dp-type-delete">
          <b>Delete</b> &mdash; permanently deletes the project and everything in it once
          approved. It cannot be recovered.
        </label>
      </div>
    </div>

    @if (deleteConfirm.type === 'delete') {
    <p>
      The project will be <b>hidden immediately</b>, along with its contacts, campaigns and
      reports, and a deletion request will be created. Once approved, it is
      <b>permanently deleted and cannot be recovered</b>.
    </p>
    }
    @if (deleteConfirm.type === 'anonymize') {
    <p>
      The project is <b>hidden immediately</b> and an anonymization request will be created.
      Once approved it <b>comes back</b> under its own name, with what is ticked above cleared.
      What is cleared cannot be brought back.
    </p>
    }
    @if (deleteConfirm.evidenceWarnings[deleteConfirm.type]) {
    <p class="small text-warning">{{ deleteConfirm.evidenceWarnings[deleteConfirm.type] }}</p>
    }
    <!-- Three cases, and the dialog must never promise an email in the third: this
         environment may send no data-protection mail at all, in which case the request is
         reviewed on the dashboard and nobody is written to. -->
    @if (deleteConfirm.emailsEnabled) {
      @if (deleteConfirm.approvers.length) {
        <p class="mb-1">An approval email will be sent to:</p>
        <ul class="ps-4 mb-3">
          @for (approver of deleteConfirm.approvers; track approver) {
          <li class="mb-1">
            <div class="fw-bold">{{ approver.name }}</div>
            <div class="small text-muted">{{ approver.email }}</div>
          </li>
          }
        </ul>
      } @else {
        <p class="text-muted">
          <i>This client has no account managers, so no approval email can be sent. The request
            will still be created and an administrator can approve it under
            <ng-container *ngTemplateOutlet="dataProtectionRef"></ng-container>.</i>
        </p>
      }
      <ng-template #noApprovers>
        <p class="text-muted">
          <i>This client has no account managers, so no approval email can be sent. The request
            will still be created and an administrator can approve it under
            <ng-container *ngTemplateOutlet="dataProtectionRef"></ng-container>.</i>
        </p>
      </ng-template>
    } @else {
      <p class="text-muted">
        <i>No approval email is sent for data protection requests here. The request will be
          created and reviewed under
          <ng-container *ngTemplateOutlet="dataProtectionRef"></ng-container>.</i>
      </p>
    }
    <ng-template #noEmails>
      <p class="text-muted">
        <i>No approval email is sent for data protection requests here. The request will be
          created and reviewed under
          <ng-container *ngTemplateOutlet="dataProtectionRef"></ng-container>.</i>
      </p>
    </ng-template>
    @if (deleteConfirm.warning) {
    <p class="text-danger">{{ deleteConfirm.warning }}</p>
    }
    @if (deleteConfirm.emailsEnabled && deleteConfirm.creatorName) {
    <p class="text-muted">
      <i>{{ deleteConfirm.creatorName }} created this project and will be notified.</i>
    </p>
    }
    <p class="mb-0">
      It can be approved@if (deleteConfirm.emailsEnabled) { from that email
        or} under
      <ng-container *ngTemplateOutlet="dataProtectionRef"></ng-container>, and cancelled
      there until the work on it starts@if (deleteConfirm.type === 'delete') {, which
        restores the project}.
    </p>
  }

  <!-- Where approvals live. Someone who can open that page is told the way to it and given
       the link (a new tab, so this dialog and the list stay put); anyone else just hears
       the page's name. -->
  <ng-template #dataProtectionRef>
    @if (currentUser()?.can('view-data-protection', 'navigation')) {
      <a [href]="'/' + routes.dataProtection()" target="_blank" rel="noopener">Admin Menu &rarr; Data Protection</a>
    } @else {the Data Protection dashboard}
    <ng-template #dataProtectionName>the Data Protection dashboard</ng-template>
  </ng-template>
</ng-template>

